import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { updateVariable, ActionTypes } from 'store/data/variables';

type HandlerInput = Parameters<typeof updateVariable>[0];

export function useUpdateVariable(): Operation<(input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.UPDATE_VARIABLE);

	async function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(updateVariable(input));
	}

	return [{ loading, error }, handler];
}
